import { CustomBreadcrumb, PageContent } from "components/Common";
import { ModuleIds } from "constant";
import PropTypes from "prop-types"
import CardDetail from "./CardDetail";
import { withTranslation } from "react-i18next";
import { useState } from "react";

const RESOURCE = ModuleIds.Test

const DetailContainer = ({ isEdit, t }) => {
    const titleTag = `Test Detail`
    const [sticky, setSticky] = useState(false);
    return (
        <PageContent title={titleTag}>
            {/* PageTitle */}
            <CustomBreadcrumb
                breadcrumbItem={t("Test List")}
                resource={RESOURCE}
                isDetail
                onSticky={(e) => {
                    setSticky(e)
                }}
            />
            {/* Page Body */}
            <CardDetail isEdit={isEdit} sticky={sticky} />
        </PageContent>
    )
}

DetailContainer.propTypes = {
    t: PropTypes.any,
    isEdit: PropTypes.bool,
}

export default withTranslation(["testPage"])(DetailContainer)